import Image from 'next/image';
import React from 'react';

const EnterpriseSecurityGovernance = () => {
    return (
        <div
            className="section-py dark:text-light border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="mb-[10px] dark:text-white"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Enterprise AI Security & Governance That Ensures Compliant, Responsible AI Deployment
                        </h2>
                        <p className="dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            AI Security & Governance ensures the safe, compliant, and ethical use of artificial intelligence across organizations. Our services help you safeguard sensitive data, maintain regulatory compliance, and build transparent AI systems. We enable you to deploy AI with confidence by establishing robust security and governance frameworks.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7 mb-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-safe-productive.svg"
                                        width={36}
                                        height={36}
                                        alt="safe-productive"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Implement AI security frameworks to prevent unauthorized access and data breaches.
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-orchestrated-agent.svg"
                                        width={36}
                                        height={36}
                                        alt="Orchestrated agents"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Develop governance policies and access controls for responsible AI usage
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-mcp-powered.svg"
                                        width={36}
                                        height={36}
                                        alt="MCP-powered controls"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Monitor AI models continuously to detect bias and ethical issues
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-ai-automation.svg"
                                        width={36}
                                        height={36}
                                        alt="AI automation"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Automate compliance reporting for GDPR, HIPAA, SOC 2, and emerging AI regulations
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnterpriseSecurityGovernance;
